module.exports = Jsw.skinUrl + "/icons/16/plesk/settings-toolbar.png?6074d526f4dc827dee3280629d2e5130";